'use strict';

var propTypes = require('./prop-types.js');
var requiredParameter = require('./required-parameter.js');
var isString = require('./is-string.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./invalid-parameter-error.js');
require('@babel/runtime/helpers/classCallCheck');
require('@babel/runtime/helpers/inherits');
require('@babel/runtime/helpers/possibleConstructorReturn');
require('@babel/runtime/helpers/getPrototypeOf');
require('@babel/runtime/helpers/wrapNativeSuper');
require('./is-defined-and-not-null.js');
require('./is-defined.js');
require('./is-null.js');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Transform a text into kebab case notation.
 *
 * @function
 * @param {string} text - Text to transform into kebab case.
 * @returns {string} Returns the kebab case version of the text passed, throw TypeError if text passed is not an string.
 * @example
 * toKebabCase('myTextToKebabCase');
 * // => 'my-text-to-kebab-case';
 */

var toKebabCase = function toKebabCase() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requiredParameter('text');

  if (isString(text)) {
    return text.match(/[AZ]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
      return x.toLowerCase();
    }).join('-');
  }

  throw new TypeError('Invalid parameter type: string expected.');
};

toKebabCase.HELPER_ID = 'Gearz.JsUtils.toKebabCase';
toKebabCase.returnType = propTypes.stringWithDescription('Returns the kebab case version of the text passed.');
toKebabCase.parameterTypes = {
  text: propTypes.stringWithDescription('Text to transform into kebab case.').isRequired
};
toKebabCase.defaultParameters = {};

module.exports = toKebabCase;
